import { render, staticRenderFns } from "./OperationPossibleResourceTable.vue?vue&type=template&id=9f22f1b2&lang=pug"
import script from "./OperationPossibleResourceTable.vue?vue&type=script&lang=js"
export * from "./OperationPossibleResourceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports